const routes = {
  path: 'contacts',
  component: () => import('@/modules/obu-contacts/index.vue'),
  children: [
    {
      path: '',
      name: 'obu-contacts',
      component: () => import('@/modules/obu-contacts/ObuContactsList.vue')
    },
    {
      path: ':id',
      name: 'obu-contacts-details',
      component: () => import('@/modules/obu-contacts/ObuContactsDetails.vue'),
      children: []
    }
  ]
}

export default routes
